import { useCallback, useMemo } from 'react';
import { PdfReader } from '@/components/shared/pdf-reader';
import { Api } from '@/constants';
import { useLessons } from '@/packages/corporate-university/context/lessons';

export const PdfLesson = () => {
  const { currentLesson, handleUpdateLessonProgress } = useLessons();
  const pdfUrl = useMemo(() => {
    if (!currentLesson?.id) return null;
    return `${Api.MediaUrl}/lessons/${currentLesson.id}/file`;
  }, [currentLesson?.id]);
  const handleLastPage = useCallback(() => {
    handleUpdateLessonProgress({
      lessonId: currentLesson?.id ?? '',
      progress: 100,
    });
  }, [currentLesson?.id, handleUpdateLessonProgress]);

  return <PdfReader fileUrl={pdfUrl} onLastPage={handleLastPage} />;
};
